import { useEffect } from "react"
import { useShallow } from "zustand/react/shallow"
import { useStateWithCallbackLazy } from "use-state-with-callback"
import TableVersionComparisonWrapper from "../../components/TableVersionComparisonWrapper/TableVersionComparisonWrapper"
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"
import useAuthoringVersionStore from "../../../hooks/stores/useAuthoringVersionStore"
import useRegistryBadges from "containers/studies/Study/subcomponents/Authoring/RJS/components/Badges/useRegistryBadges/useRegistryBadges"

// components
import Msc from "./Msc"
import "./member-states-concerned.scss"

const MSCWrapper = (props) => {
  const { onChange } = props
  const { getBadges } = useRegistryBadges()

  const { formData } = props.formContext

  const { versionData, selectedVersion } = useAuthoringVersionStore(
    useShallow((state) => ({
      versionData: state.versionData,
      selectedVersion: state.selectedVersion,
    }))
  )

  const { readOnly, showVersionCompare, formStatus, showRegistryBadges } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      showVersionCompare: state.showVersionCompare,
      formStatus: state.formStatus,
      showRegistryBadges: state.showRegistryBadges,
    }))
  )

  const [tableData, setTableData] = useStateWithCallbackLazy([])
  const [tableMounting, setTableMounting] = useStateWithCallbackLazy(true)

  useEffect(() => {
    if (formStatus === "ready" && tableData && readOnly === false && tableMounting === false) {
      console.log("MSC Change")
      onChange(tableData)
    }
  }, [tableData])

  useEffect(() => {
    if (props.value) {
      setTableData(props.value, () => {
        setTableMounting(false)
      })
    } else {
      setTableData([], () => {
        setTableMounting(false)
      })
    }

    return () => {
      setTableMounting(true)
    }
  }, [])

  if (tableMounting) return <></>

  return (
    <div className={["form-table-print", "msc-wrapper"].join(" ")}>
      {showRegistryBadges && <div className="registry-badge-container">{getBadges(["ctis"])}</div>}
      <Msc
        {...props}
        protocolData={formData?.protocol}
        tableData={tableData}
        setTableData={setTableData}
      />
      {versionData && selectedVersion && showVersionCompare && (
        <TableVersionComparisonWrapper>
          <Msc
            {...props}
            protocolData={versionData?.study_data?.protocol}
            tableData={versionData?.study_data?.protocol?.mscs?.member_states_concerned?.member_states_concerned_table}
            setTableData={() => {}}
          />
        </TableVersionComparisonWrapper>
      )}
    </div>
  )
}

export default MSCWrapper
